// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import {
  generateTransition,
  easeInOut,
  delayAction
} from "@fdr/static-ui/Transitions";
import fanduelRotated from "@fdr/static-ui/images/fanduel-rotated.svg";

export const BetList = styled.div`
  margin: 0;
  padding: 0;

  & ul {
    ${({ isFromResultedBetTab }) =>
      isFromResultedBetTab &&
      css`
        background-color: ${buildColor("white", "100")};
        border: 1px solid ${buildColor("grey", "300")};
        border-radius: 4px;
        padding: 0 16px;
        height: 100%;
      `}
    list-style: none;
  }

  ${({ showRace }) =>
    !showRace &&
    css`
      flex: 1;
      padding: 12px 16px;
      background-color: ${buildColor("white", "100")};
    `};
  ${({ isFromResultedBetTab }) =>
    isFromResultedBetTab &&
    css`
      background-color: ${buildColor("grey", "100")};
    `}
`;

export const BetListItem = styled.li`
  transition: ${generateTransition(easeInOut, "opacity", "2.7s")},
    ${generateTransition(easeInOut, "min-height", "2.9s")},
    ${generateTransition(easeInOut, "max-height", "2.9s")},
    ${generateTransition(easeInOut, "margin", "2.9s")},
    ${generateTransition(easeInOut, "border", "2.9s")};
  padding: 0 16px 12px;
  ${({ isWinningBet }) =>
    isWinningBet &&
    css`
      background-image: url("${fanduelRotated}");
      background-repeat: no-repeat;
      background-position: top right;
    `};

  & .betSummaryMessage {
    padding: 0;
    max-height: 0;
    margin: 0;
    opacity: 0;
    transition: ${generateTransition(delayAction, "max-height", "0.9s")},
      ${generateTransition(delayAction, "padding", "0.9s")},
      ${generateTransition(delayAction, "margin", "0.9s")},
      ${generateTransition(easeInOut, "opacity", "1s")};
  }

  & .betSummary {
    transition: ${generateTransition(easeInOut, "opacity", "0.5s")},
      ${generateTransition(easeInOut, "max-height", "0.7s")},
      ${generateTransition(easeInOut, "padding", "0.7s")},
      ${generateTransition(easeInOut, "margin", "0.7s")};
  }

  &.bet-list-item-exit {
    opacity: 1;
    max-height: 250px;
    min-height: 0;

    & .betSummary {
      opacity: 1;
      max-height: 250px;
    }

    & .betSummaryMessage {
      opacity: 1;
      margin-top: 12px;
      max-height: 60px;
    }
  }

  &.bet-list-item-exit-active {
    padding: 0;
    border: 0;
    opacity: 0;
    margin: 0;
    max-height: 0;
    min-height: 0;
    overflow: hidden;

    & .betSummary {
      opacity: 0;
      max-height: 0;
      padding: 0;
      margin: 0;
    }
  }
`;

export const MessageWrapper = styled.div`
  margin-bottom: 12px;
  margin-top: 4px;

  & > div {
    height: 44px;
    padding-left: 12px;
  }
`;

export const EmptyMessageWrapper = styled.div`
  flex-grow: 1;
  background-color: ${buildColor("grey", "100")};
  display: flex;
`;

export const EmptyMessageCard = styled.div`
  flex-grow: 1;
  background-color: ${buildColor("white", "100")};
  margin: 12px 16px;
  border-radius: 4px;
  border: 1px solid ${buildColor("grey", "300")};
  display: grid;
  place-items: center;
`;
